import { useState, useEffect } from 'react';
import Translator from '../../../classes/Translator/Translator';


const CounterLogic = (props) => {
  const { type, isBackgroundWhite } = props;
  const { translator } = Translator();


  const [values, setValues] = useState({
    ...props,
    rootClass: 'root',
    isBackgroundWhite: isBackgroundWhite ? 'backgroundWhiteRoot' : null,
  });

  const setClass = () => {
    if (type === 'normal') {
      setValues({
        ...values,
        rootClass: 'root',
        buttonClass: 'button',
        counterClass: 'counterClass',
      });
    } else if (type === 'small') {
      setValues({
        ...values,
        rootClass: 'smallRoot',
        buttonClass: 'smallButton',
        counterClass: 'counterClass',      });
    }
  };

  useEffect(() => {
    setClass();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    values,
    translator,

  };
};

export default CounterLogic;
